<template>
    <div class="v-card__title">
        <botao-assinar-documento-em-lote
            v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'"
            :deveHabilitarBotoes="deveHabilitarBotoes"
            @assinarDocumentosEmLote="$emit('assinarDocumentosEmLote')"/>

        <botao-juntar-documento-em-lote
            v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'"
            :deveHabilitarBotoes="deveHabilitarBotoes"
            @juntarDocumentosEmLote="$emit('juntarDocumentosEmLote')"/>

        <botao-baixar-documento-em-lote :deveHabilitarBotoes="deveHabilitarBotoes" @baixarDocumentoEmLote="$emit('baixarDocumentoEmLote')"/>
        <v-spacer></v-spacer>
    </div>
</template>

<script>
import BotaoAssinarDocumentoEmLote from '../components/BotaoAssinarDocumentoEmLote'
import BotaoJuntarDocumentoEmLote from '../components/BotaoJuntarDocumentoEmLote'
import BotaoBaixarDocumentoEmLote from '../components/BotaoBaixarDocumentoEmLote'

export default {
    name: 'ListarDocumentosHeaderBotoesBarra',
    components: {BotaoBaixarDocumentoEmLote, BotaoJuntarDocumentoEmLote, BotaoAssinarDocumentoEmLote},
    props: {
        deveHabilitarBotoes: {
            type:Boolean,
            default: false
        }
    }
}
</script>

<style scoped lang="stylus">

</style>